import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { MainGuard } from './guards/main.guard';

const routes: Routes = [
  {
    path: 'signin-oidc',
    loadChildren: () => import('./pages/landing/landing.module').then((m) => m.LandingModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'main',
    loadChildren: () => import('./pages/main/main.module').then((m) => m.MainModule),
    canActivate: [MainGuard]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'signin-oidc'
  },
  {
    path: '**',
    redirectTo: 'main/home'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
